import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moduleName',
  standalone: true,
})
export class ModuleNamePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'products':
        return 'Productos principales';
      case 'mechanics':
        return 'Mecánica del concurso';
      case 'tips':
        return 'Tips para ganar más';
      case 'stores':
        return 'Top tiendas ganadoras';
      case 'payments':
        return 'Fechas de pago';
      case 'results':
        return 'Bases y resultados semanales';

      default:
        return 'Sección';
    }
  }
}
